import { forwardRef } from 'react';
import {
  ChartVisualization as QuantChartVisualization,
  type ChartVisualizationProps,
  type ChartVisualizationRef,
} from '@trinity/chat-components/components/QuantAnalysis/ChartVisualization.js';
import { useChartColors } from '@/screens/Project.QuantAnalysis/hooks/useChartColors';

export type { ChartVisualizationRef };

type Props = Omit<ChartVisualizationProps, 'colors'> & {
  selectedThemeId?: number | null;
};

/**
 * The chart itself lives in chat-components. This wrapper only resolves the theme palette,
 * since that depends on the app's own branding contexts.
 */
export const ChartVisualization = forwardRef<ChartVisualizationRef, Props>(
  ({ selectedThemeId = null, ...props }, ref) => {
    const colors = useChartColors(selectedThemeId);
    return <QuantChartVisualization ref={ref} colors={colors} {...props} />;
  }
);

ChartVisualization.displayName = 'ChartVisualization';
